/** @jsx jsx */
import { bool } from 'prop-types'
import { jsx } from 'theme-ui'
import { Link } from 'gatsby'

// header navigation links for client routes
const NavLink = ({ disabled, ...props }) => (
  <Link
    sx={{
      variant: 'links.navigation',
      pointerEvents: disabled ? 'none' : 'auto',
      mx: 4,
    }}
    {...props}
  />
)

NavLink.propTypes = {
  disabled: bool,
}

export default NavLink
